export const TRPC_URL =
  `${process.env.NEXT_PUBLIC_BACKEND ?? ''}/api/trpc`
    // ?? 'http://127.0.0.1:3009/trpc';

// export const ADMIN_TRPC_URL =
//   `${process.env.NEXT_ADMIN_BACKEND ?? ''}/api/admin/trpc` ??
//   'http://localhost:3023/api/admin/trpc';

export const ADMIN_TRPC_URL =
  process.env.NEXT_PUBLIC_ADMIN_TRPC_URL ??
  'http://localhost:3023/api/admin/trpc';
